<ion-col>
	<ion-row class="ion-justify-content-center tips-row">
		@for (tip of tips; track tip) {
			<div (click)="selectTip(tip)" [class.active]="selectedTip === tip" class="tip-option">
				<span class="tip-option-text">{{ text(tip) }}</span>
				@if (selectedTip === tip) {
					<ion-icon class="check-icon" name="checkmark-circle"></ion-icon>
				}
				<span class="tip-icon">{{ tip.icon }}</span>
			</div>
		}
	</ion-row>
	<ion-row class="ion-justify-content-center">
		<div (click)="selectAbsolute()" class="no-tip">{{ 'tipSelector.other' | translate }}</div>
	</ion-row>
</ion-col>
